import { Container } from "./styles";
import React from "react";
import { FadeIn } from "../FadeIn";

export function Hero() {
  return (
    <Container id="home">
      <div className="hero-text">
        <FadeIn delay={0}>
          <p>Hi! 👋, I'm</p>
        </FadeIn>
        <FadeIn delay={200}>
          <h1>Sarah Schoonmaker</h1>
        </FadeIn>
        <FadeIn delay={400}>
          <h3>Data Engineer</h3>
        </FadeIn>
        <FadeIn delay={600}>
          <p>
            Designing and building scalable data pipelines connecting to
            applications and data visualization interfaces that serve millions
            of users in the fintech and e-commerce industries. Skilled in
            Python, SQL, AWS (Redshift, Glue, Lambda, S3), Airflow, and
            Streamlit - Bridging backend data engineering with clean,
            data-driven user experiences.
          </p>
        </FadeIn>
      </div>
    </Container>
  );
}
